exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-00d4caad]{margin-bottom:30px}form[data-v-00d4caad]{display:-ms-flexbox;display:-webkit-box;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;width:80%;max-width:800px;margin:auto}input[data-v-00d4caad]{max-width:300px;height:40px}textarea[data-v-00d4caad]{height:140px}input[data-v-00d4caad],textarea[data-v-00d4caad]{margin-bottom:10px;width:100%;background-color:transparent;border:2px var(--c-footer-bg) solid;border-radius:5px}label[data-v-00d4caad]{margin-bottom:5px}button[data-v-00d4caad]{background-color:transparent;border:1px solid #000;border-radius:5px;padding:5px 10px 7px}button[data-v-00d4caad]:hover{background-color:var(--c-footer-bg);color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00d4caad","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Contact.vue
// module id = 261
// module chunks = 0